import { render, staticRenderFns } from "./LaundryLabelTemplate.vue?vue&type=template&id=4c584e2b&scoped=true&"
import script from "./LaundryLabelTemplate.vue?vue&type=script&lang=js&"
export * from "./LaundryLabelTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LaundryLabelTemplate.vue?vue&type=style&index=0&id=4c584e2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c584e2b",
  null
  
)

export default component.exports